var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpenEye = function SvgOpenEye(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 16,
    "data-width-24": 24,
    viewBox: "0 0 23.5 16.4",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.502 9.58c1.64 2.03 6.02 6.76 11.25 6.76s9.61-4.73 11.25-6.76a2.23 2.23 0 0 0 0-2.82c-1.64-2.03-6-6.76-11.25-6.76S2.142 4.76.502 6.76a2.23 2.23 0 0 0 0 2.82m1.17-1.87c1.5-1.87 5.5-6.21 10.08-6.21s8.58 4.34 10.08 6.21a.72.72 0 0 1 0 .92c-1.5 1.87-5.5 6.21-10.08 6.21s-8.58-4.34-10.08-6.21a.72.72 0 0 1 0-.92m7.191 4.784a5.2 5.2 0 1 0 5.778-8.648 5.2 5.2 0 0 0-5.778 8.648m.834-7.4a3.7 3.7 0 1 1 4.11 6.152 3.7 3.7 0 0 1-4.11-6.152",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenEye);
export default ForwardRef;